<div class="py-7 px-8">
    @if (title || subtitle) {
        <div class="mb-4">
            @if (title) {
                <h1 class="mb-1">{{title}}</h1>
            }
            @if (subtitle) {
                <label class="text-lg">{{subtitle}}</label>
            }
        </div>
    }
    <div class="w-full">
        <ng-content></ng-content>
    </div>
</div>